import { type Initializer, initOnce } from '@/generic/init/Init.ts';

export const useInitOnce = (key: symbol, initializer: Initializer) => initOnce(key, initializer);
